// extracted by mini-css-extract-plugin
export default {"inputControl":"Signup_inputControl__BsL6r","pageTitle":"Signup_pageTitle__dHt6Q","button":"Signup_button__Riq5W","errorBox":"Signup_errorBox__aULIn"};